import { UserRound, Pencil } from "lucide-react";

export const IdentityBar = ({ name, team, onEdit, disabled }) => (
  <div className="flex items-center justify-between rounded-2xl bg-white/[0.04] border border-white/[0.06] px-4 py-3" data-testid="identity-bar">
    <div className="flex items-center gap-3">
      <span className="w-9 h-9 rounded-full bg-[#007AFF]/15 text-[#3B9BFF] flex items-center justify-center"><UserRound className="w-4 h-4" /></span>
      <div>
        <div className="text-[11px] text-neutral-500">Testing as</div>
        <div className="text-sm text-white font-medium" data-testid="identity-text">{name} <span className="text-neutral-500 font-normal">· {team}</span></div>
      </div>
    </div>
    <button data-testid="change-identity-button" onClick={onEdit} disabled={disabled} className="rounded-full bg-white/[0.06] hover:bg-white/10 px-3 py-1.5 text-xs text-neutral-300 flex items-center gap-1 transition-colors">
      <Pencil className="w-3 h-3" /> Change
    </button>
  </div>
);
